import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=6f526281&"
import script from "./TaskList.vue?vue&type=script&lang=ts&"
export * from "./TaskList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports